import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllWalletPricing = () => {
  const [allWallet, setAllWallet] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/bonus`)
      .then((result) => {
        console.log(result.data?.data);
        const data = result.data?.data;
        setAllWallet(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleAddWalletPricing = () => {
    navigate("/add-wallet-pricing");
  };
  const handleViewAllWalletPricing = () => {
    navigate("/all-wallet-pricing");
  };

  const handleEdit = (id) => {
    navigate(`/edit-wallet-pricing/${id}`);
  };

  const handleDelete = (id) => {
    if (
      window.confirm("Are you sure you want to delete this wallet pricing?")
    ) {
      axios
        .delete(`${API_BASE_URL}/pricing/bonus/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          console.log("Deleted successfully", response.data);
          // Filter out the deleted item from the state
          setAllWallet(allWallet.filter((wallet) => wallet._id !== id));
        })
        .catch((error) => {
          console.error("Error deleting wallet pricing:", error);
        });
    }
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Wallet Pricing</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={handleAddWalletPricing}
            >
              + Add New Wallet Pricing
            </button>
            <button
              className="allSubjects"
              onClick={handleViewAllWalletPricing}
            >
              All Wallet Pricing
            </button>
          </div>
        </div>

        <div className="classes-table-container">
          <h5>All Wallet Pricing</h5>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Point</th>
                <th>Value</th>
                <th>Bonus</th>
                <th>Percentage</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {allWallet &&
                allWallet.map((data, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{data.point}</td>
                    <td>{data.value}</td>
                    <td>{data.bonus}</td>
                    <td>{data.percentage}</td>

                    <td className="table-action-icons">
                      <i
                        className="fa-solid fa-file-pen"
                        onClick={() => handleEdit(data._id)}
                      ></i>
                      &nbsp;&nbsp;
                      <i
                        className="fa-solid fa-trash-can"
                        onClick={() => handleDelete(data._id)}
                      ></i>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllWalletPricing;
